import swap from './swap-breakdowns-animation'
import plotChange from './plot-change-animation'
import fromLine from './from-line-animation'
import fromArea from './from-area-animation'
import fromPie from './from-pie-animation'
import hierarchyDrilldown from './hierarchy-drilldown-animation'
import hierarchyDrillup from './hierarchy-drillup-animation'
import addBreakdownSplit from './add-breakdown-split-animation'
import addBreakdownShuffle from './add-breakdown-shuffle-animation'
import removeBreakdownSplit from './remove-breakdown-split-animation'
import removeBreakdownShuffle from './remove-breakdown-shuffle-animation'
import removeInnerStack from './remove-inner-stack-animation'
import addInnerStack from './add-inner-stack-animation'
import noBreakdownSerieAdd from './no-breakdown-serie-add-stack' // Before sliding
import noBreakdownSerieStack from './no-breakdown-serie-stack-order-animation'
import slidingAnimation from './sliding-animation'
import splitAdd from './split-add-animation'
import splitRemove from './split-remove-animation'
import nonSlidingRange from './non-sliding-range-change-animation' // After sliding-animati,
import basic from './basic-animation' // Run last which will make sure something gets to the right position if another, more specific, animation didn't mat,

// Order matters. If one of the animations is a match when the controller
// tries to determine which animation to run, it stops looking at the others
export default [
  swap,
  plotChange,
  fromLine,
  fromArea,
  fromPie,
  hierarchyDrilldown,
  hierarchyDrillup,
  addBreakdownSplit,
  addBreakdownShuffle,
  removeBreakdownSplit,
  removeBreakdownShuffle,
  removeInnerStack,
  addInnerStack,
  noBreakdownSerieAdd,
  noBreakdownSerieStack,
  slidingAnimation,
  splitAdd,
  splitRemove,
  nonSlidingRange,
  basic
]
